import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMRoomBlockResource {
  
  static getBlock(id, completion){
    const url = "/1/room_block_schedules/" + id + ".json";
    const apiClient = new SMRestClient();
    apiClient.get(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static postBlock(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_block_schedules.json" + q;  
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static updateBlock(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_block_schedules/" + id + ".json" + q;  
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static deleteBlock(id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_block_schedules/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
};
export default SMRoomBlockResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMRoomBlockResource.js